export enum PartCategoryEnum {
	SHELVES = 'shelves',
	POSTS = 'posts',
	BEAMS = 'beams',
	HANG_RODS = 'hang rods',
	REBAR = 'rebar',
	HARDWARE = 'hardware',
	PLATES = 'plates'
}
